<template>
  <div
    :style="{ fontSize: size + 'px', position: 'relative' }"
    class="pallet-rack-section--component"
  >
    <div
      :style="{
        height: mmToEm(selectedHeight),
        marginTop: '2rem'
      }"
    >
      <div
        :style="{
          position: 'absolute',
          left: mmToEm(
            (includeImpactProtectors ? 180 : 0) +
              index * (sector.beam.length + selectedUprights.width)
          )
        }"
      >
        <div
          :style="{
            position: 'relative'
          }"
        >
          <!-- FRONT VIEW -->
          <pallet-rack-gable
            :is-leftmost="isLeftmost"
            :is-rightmost="isRightmost"
            :sector="sector"
          />

          <div
            v-for="(level, i) in levels"
            :key="i"
            :style="{
              position: 'absolute',
              left: mmToEm(selectedUprights.width - 30),
              top: mmToEm(selectedHeight - level),
              width: mmToEm(sector.beam.length + 60),
              zIndex: 1001
            }"
          >
            <pallet-rack-level
              :index="i"
              :sector="sector"
            />
          </div>

          <div
            :style="{
              position: 'relative',
              top: selectedHeight / 1000 + 1 + 'em'
            }"
          >
            <!-- TOP VIEW -->
            <div
              :style="{
                left: 0,
                top: mmToEm(150),
                position: 'absolute'
              }"
            >
              <pallet-rack-gable-top
                :is-leftmost="isLeftmost"
                :is-rightmost="isRightmost"
                :sector="sector"
                :is-upper="true"
              />
              <!-- <div
                :style="{
                  position: 'absolute',
                  top: mmToEm(55),
                  left: mmToEm(selectedUprights.width + 10),
                  width: mmToEm(40),
                  height: mmToEm(1100 - 110),
                  background: 'linear-gradient(180deg, rgba(230,15,0,1) 0%, rgba(210,15,0,1) 100%)',
                  zIndex: 1000
                }"
              ></div>-->
              <div
                :style="{
                  position: 'absolute',
                  background:
                    'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                  left: mmToEm(selectedUprights.width),
                  width: mmToEm(sector.beam.length),
                  height: mmToEm(55),
                  top: mmToEm(doubleRack ? 25 : 0)
                }"
              />
              <!-- <div
                :style="{
                  position: 'absolute',
                  background: 'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                  left: mmToEm(selectedUprights.width),
                  top: mmToEm(450),
                  width: mmToEm(sector.beam.length),
                  height: mmToEm(40)
                }"
              ></div>
              <div
                :style="{
                  position: 'absolute',
                  background: 'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                  left: mmToEm(selectedUprights.width),
                  top: mmToEm(650),
                  width: mmToEm(sector.beam.length),
                  height: mmToEm(40)
                }"
              ></div>-->

              <div
                :style="{
                  position: 'absolute',
                  background:
                    'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                  left: mmToEm(selectedUprights.width),
                  top: mmToEm(1100 - 55 + (doubleRack ? 25 : 0)),
                  width: mmToEm(sector.beam.length),
                  height: mmToEm(55)
                }"
              />
              <!-- Pallet -->
              <div
                :style="{
                  position: 'relative',
                  top: mmToEm(-50 + (doubleRack ? 25 : 0)),
                  left: mmToEm(selectedUprights.width),
                  width: mmToEm(sector.beam.length),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around'
                }"
              >
                <template v-for="pallet in sector.beam.pallets">
                  <div
                    :key="`top-${index}:${pallet}`"
                    class="pallet-level-pallet"
                    :style="{
                      borderSize: 'border-box',
                      width: mmToEm(800),
                      height: mmToEm(1200),
                      backgroundColor: '#fce2c9'
                    }"
                  />
                </template>
              </div>
            </div>

            <div
              v-if="doubleRack"
              :style="{
                left: 0,
                top: mmToEm(1100 + 250 + 150),
                position: 'absolute'
              }"
            >
              <pallet-rack-gable-top
                :is-leftmost="isLeftmost"
                :is-rightmost="isRightmost"
                :sector="sector"
                :is-upper="false"
              />
              <div
                :style="{
                  position: 'absolute',
                  background:
                    'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                  left: mmToEm(selectedUprights.width),
                  width: mmToEm(sector.beam.length),
                  height: mmToEm(55),
                  top: mmToEm(-25)
                }"
              />
              <div
                :style="{
                  position: 'absolute',
                  background:
                    'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(230,15,0,1) 3%, rgba(210,15,0,1) 97%, rgba(130,15,0,1) 100%)',
                  left: mmToEm(selectedUprights.width),
                  top: mmToEm(1100 - 80),
                  width: mmToEm(sector.beam.length),
                  height: mmToEm(55)
                }"
              />
              <!-- Pallet -->
              <div
                :style="{
                  position: 'relative',
                  top: mmToEm(-75),
                  left: mmToEm(selectedUprights.width),
                  width: mmToEm(sector.beam.length),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around'
                }"
              >
                <template v-for="pallet in sector.beam.pallets">
                  <div
                    :key="`top2-${index}:${pallet}`"
                    class="pallet-level-pallet"
                    :style="{
                      borderSize: 'border-box',
                      width: mmToEm(800),
                      height: mmToEm(1200),
                      backgroundColor: '#fce2c9'
                    }"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PalletRackGable from "./PalletRackGable";
import PalletRackGableTop from "./PalletRackGableTop";
import PalletRackLevel from "./PalletRackLevel";

let calcLevelDistance = (height, count) => {
  let distance = height / count;
  distance = Math.ceil(distance / 10) * 10; // Make multiples of 10
  return distance;
};

let distributeLevels = (height, levelCount) => {
  let levels = [];
  let levelDistance = calcLevelDistance(height, levelCount);
  for (let y = 0; y < levelCount; y += 1) {
    levels.push(y * levelDistance);
  }
  return levels;
};

export default {
  components: {
    PalletRackGable,
    PalletRackGableTop,
    PalletRackLevel
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["index", "size", "sector"],
  computed: {
    ...mapState([
      "selectedUprights",
      "selectedHeight",
      "sectors",
      "doubleRack",
      "includeImpactProtectors"
    ]),

    levelDistance() {
      return calcLevelDistance(
        this.selectedHeight,
        Number(this.sector.levelCount) + 1
      );
    },

    levels() {
      return distributeLevels(
        this.selectedHeight,
        Number(this.sector.levelCount) + 1
      );
    },

    isLeftmost() {
      if (this.sector && this.sectors) {
        return this.sector.index == 0 && this.index == 0
      }
      return false
    },

    isRightmost() {
      if (this.sector && this.sectors) {
        return (
          this.sector.index == this.sectors.length - 1 &&
          this.index == Number(this.sector.sectionCount) - 1
        )
      }
      return false
    }
  },

  methods: {
    mmToEm(mm) {
      return mm / 1000 + "em"
    }
  }
}
</script>

<style>
.section-overlay {
  opacity: 0;
}

.section-overlay:hover {
  animation: opacityPulse 1s ease-out;
  animation-iteration-count: infinite;
  opacity: 0.35;
}

.section-overlay.selected {
  opacity: 0;
}

@-webkit-keyframes opacityPulse {
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.45;
  }
  100% {
    opacity: 0.2;
  }
}
</style>
